import { render } from "./BasicViewer.vue?vue&type=template&id=53676122"
import script from "./BasicViewer.vue?vue&type=script&lang=js"
export * from "./BasicViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__